import { reduxKey } from '../../constants';
export const getGruser = (state)=>{
    var _state_reduxKey;
    return (_state_reduxKey = state[reduxKey]) === null || _state_reduxKey === void 0 ? void 0 : _state_reduxKey.gruser;
};
